var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as Actions from '../actions/register.actions';
var initialState = {
    success: false,
    confirm: false,
    error: {
        username: null,
        password: null,
        code: null,
    },
};
var register = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case Actions.REGISTER_SUCCESS:
            return __assign(__assign({}, initialState), { success: true, confirm: false });
        case Actions.REGISTER_ERROR:
            return {
                success: false,
                error: action.payload,
            };
        case Actions.REGISTER_CONFIRM: {
            return __assign(__assign({}, initialState), { confirm: true });
        }
        default:
            return state;
    }
};
export default register;



//////////////////
// WEBPACK FOOTER
// ./src/auth/store/reducers/register.reducer.ts
// module id = 1484
// module chunks = 81